import { HugeiconsIcon } from '@hugeicons/react';
import {
  Award01Icon,
  BulbIcon,
  FolderKanbanIcon,
  HelpCircleIcon,
  LibraryIcon,
  Message01Icon,
  PlayIcon,
  Rocket01Icon,
  SecurityCheckIcon,
} from '@hugeicons/core-free-icons';

const ICON_MAP = {
  'comenzar-aqui': Rocket01Icon,
  biblioteca: LibraryIcon,
  'prompt-library': Message01Icon,
  projects: FolderKanbanIcon,
  'buenas-practicas': BulbIcon,
  videos: PlayIcon,
  'casos-exito': Award01Icon,
  faq: HelpCircleIcon,
  'uso-seguro': SecurityCheckIcon,
};

export function CategoryIcon({ slug, className = 'h-5 w-5' }) {
  return <HugeiconsIcon icon={ICON_MAP[slug] || LibraryIcon} className={className} aria-hidden="true" />;
}
